import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { REGULATOR } from 'config/permissions/roles';
import messageService from 'services/message.service';
import bulkUsageData from '../common/bulk-usage-data/bulk-usage-data.module';
import dashboardComponent from './dashboard.component';
import message from './message/message.module';
import messageEdit from './message-edit/message-edit.module';
import './dashboard.scss';

export default
  angular.module('components.app.dashboard', [
    uiRouter,
    bulkUsageData,
    message,
    messageEdit
  ])
    .component('dashboard', dashboardComponent)
    .service('MessageService', messageService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('dashboard', {
          parent: 'app',
          url: '/dashboard',
          component: 'dashboard',
          data: {
            permissions: {
              except: [`${REGULATOR}`],
              redirectTo: 'adverseEvents'
            }
          },
          resolve: {
            adminMessage: MessageService =>
              MessageService.getAdminMessage().then(r => r.data),
            alerts: AlertService =>
              AlertService.getAlerts().then(r => r.data),
            companyMessage: ($log, MessageService) =>
              MessageService.getCompanyMessage().then(r => r.data).catch(error => $log.error(error)),
            flex: () => '100',
            layout: () => 'column'
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/dashboard/dashboard.module.js